import { RootState } from '../reducers'

export const weeklySchedulesSelector = (state: RootState, id: number) => state.weeklySchedules.items[id]
